window.addEventListener('error', e => {
  const message = e?.message || '';
  const errorName = e?.error?.name || '';
  const isChunkLoadError = errorName === 'ChunkLoadError'
      || message.includes('Loading chunk')
      || message.includes('Loading CSS chunk')
      || message.includes('CssChunkLoadError');

  if (isChunkLoadError) {
    window.location.reload();
  }
});

// Strip the `_cb` cache-bust query param added by RouteErrorBoundary after a
// reload, so it does not linger in the visible URL. Uses replaceState so no
// navigation is triggered.
(function stripCacheBustParam() {
  try {
    const params = new URLSearchParams(window.location.search);
    if (!params.has('_cb')) return;
    params.delete('_cb');
    const query = params.toString();
    const cleanUrl = window.location.pathname
      + (query ? `?${query}` : '')
      + window.location.hash;
    window.history.replaceState(window.history.state, '', cleanUrl);
  } catch {
    // ignore — URL cleanup is purely cosmetic
  }
}());
